"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewTitle = exports.Subtitle = exports.Right = exports.Left = exports.Heading = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../../styles/palette");
var _flex = _interopRequireDefault(require("../../../styles/flex"));
var _typefaces = _interopRequireDefault(require("../../../styles/typefaces"));
var _partials = require("../../../styles/partials");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ViewTitle = exports.ViewTitle = _styledComponents["default"].div.withConfig({
  displayName: "styles__ViewTitle",
  componentId: "sc-1cwmjfd-0"
})(["", ";padding-bottom:30px;"], _flex["default"].horizontal);
var Left = exports.Left = _styledComponents["default"].div.withConfig({
  displayName: "styles__Left",
  componentId: "sc-1cwmjfd-1"
})(["", ";flex-grow:1;"], _flex["default"].allowOverflowX);
var Right = exports.Right = _styledComponents["default"].div.withConfig({
  displayName: "styles__Right",
  componentId: "sc-1cwmjfd-2"
})(["display:flex;align-items:flex-end;height:40px;"]);
var Heading = exports.Heading = _styledComponents["default"].h3.withConfig({
  displayName: "styles__Heading",
  componentId: "sc-1cwmjfd-3"
})(["", ";", ";font-weight:300;"], _typefaces["default"].sidebar.title, _partials.truncate);
var Subtitle = exports.Subtitle = _styledComponents["default"].p.withConfig({
  displayName: "styles__Subtitle",
  componentId: "sc-1cwmjfd-4"
})(["margin-top:10px;color:", ";"], _palette.commonPalette.txGrey);
//# sourceMappingURL=styles.js.map